<div class="agent-typing" aria-hidden="true">
  @if (verb()) {
    <span class="agent-typing__verb">{{ verb() }}</span>
  }
  <span class="agent-typing__dots">
    <span class="agent-typing__dot"></span>
    <span class="agent-typing__dot"></span>
    <span class="agent-typing__dot"></span>
  </span>
</div>
